import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  getPropertyDetail: null,
  getUserProfileDetail: null,
  getAllLicenseInfo: {
    response: {
      CORP: [],
      INDV: [],
    },
  },
  getListingID: null,
};

const propertySliceDetail = createSlice({
  name: "propertyDetail",
  initialState,
  reducers: {
    setPropertyDetailData: (state, action) => {
      state.getPropertyDetail = action.payload;
    },
    setUserProfileData: (state, action) => {
      state.getUserProfileDetail = action.payload;
    },
    setListingId: (state, action) => {
      state.getListingID = action.payload;
    },
    setAllLicenseInfo: (state, action) => {
      state.getAllLicenseInfo = {
        response: {
          // CORP: action.payload?.response?.CORP || [],
          // INDV: action.payload?.response?.INDV || [],
          CORP: [
            // ...(state.getAllLicenseInfo.response.CORP || []),
            ...(action.payload?.response?.CORP || []),
          ],
          INDV: [
            // ...(state.getAllLicenseInfo.response.INDV || []),
            ...(action.payload?.response?.INDV || []),
          ],
        },
      };
    },
    // setAllLicenseInfo: (state, action) => {
    //   state.getAllLicenseInfo = {
    //     response: {
    //       CORP: action.payload?.response?.CORP || [],
    //       INDV: action.payload?.response?.INDV || [],
    //     },
    //   };
    // },
  },
});

export const {
  setPropertyDetailData,
  setUserProfileData,
  setAllLicenseInfo,
  setListingId,
} = propertySliceDetail.actions;
export default propertySliceDetail.reducer;
